import { render } from "./TermsFollowChips.vue?vue&type=template&id=d03a10c6&scoped=true"
import script from "./TermsFollowChips.vue?vue&type=script&lang=js"
export * from "./TermsFollowChips.vue?vue&type=script&lang=js"

import "./TermsFollowChips.vue?vue&type=style&index=0&id=d03a10c6&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\wordpress\\wp-content\\themes\\yka-theme-2022\\vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d03a10c6"]])

export default __exports__